import { Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

/** 读者管理页面（占位，后续需求实现 CRUD） */
export default function ReadersPage() {
  return (
    <div>
      <Title level={3}>
        <TeamOutlined /> 读者管理
      </Title>
      <Text type="secondary">读者 CRUD 功能将在后续需求中实现。</Text>
    </div>
  );
}
